import { kebabCase } from 'lodash'
import React from 'react'
import CheckIcon from './icons/check'
import StyledImage from './styled-image'
import "../styles/table.css"
import XIcon from './icons/x-icon'

export default function Table({ props, index }) {
    const { heading, columnHeadings, rows } = props
    return (
        <section className="py-12 xl:container pl-4 md:pl-6 lg:pr-6 table-section" id={heading ? kebabCase(heading) : index ? `section-${index}` : null}>
            {heading ?
                <h2 className="mb-6 text-left">{heading}</h2>
                : null}
            <div className="overflow-x-auto">
                <table className="">
                    <thead>
                        <tr>
                            <th className="th-row" scope="row" aria-label="This space intentionally left blank"></th>
                            {columnHeadings?.map((column) => {
                                const { columnHeading, columnSubheading, columnImage } = column
                                return (
                                    <th key={columnHeading} className="align-top th-col" scope="col">
                                        <p className='h3 mb-1'>{columnHeading}</p>
                                        <StyledImage className="w-32 mb-1 px-1 md:px-2 mx-auto" image={columnImage} />
                                        <p className='text-xs xl:text-sm leading-tight'>{columnSubheading}</p>
                                    </th>
                                )
                            }
                            )}
                        </tr>
                    </thead>
                    <tbody>
                        {rows?.map((row, rowIndex) => {
                            const { rowHeading, rowType, rowValues } = row
                            return (
                                <tr>
                                    <th scope="row" className="text-right align-middle lg:whitespace-nowrap th-row" aria-label="Table heading" dangerouslySetInnerHTML={{ __html: rowHeading, }} />
                                    {rowValues?.map((cell, columnIndex) => {
                                        const { isChecked, text, subtext } = cell
                                        return (
                                            <td className="text-center align-middle" key={rowIndex + "-" + columnIndex}>
                                                {rowType === "text" ?
                                                    <>
                                                        <p dangerouslySetInnerHTML={{ __html: text, }} />
                                                        <p className="text-xs" dangerouslySetInnerHTML={{ __html: subtext, }} />
                                                    </>
                                                    : isChecked ?
                                                        <CheckIcon style={{ color: columnHeadings[columnIndex].columnColor }} className="w-7 mx-auto" />
                                                        : <XIcon className="w-6 mx-auto text-gray-200 sm:hidden" />}
                                            </td>
                                        )
                                    })}
                                </tr>
                            )
                        })}
                    </tbody>
                </table>
            </div>
        </section>
    )
}
